import { Machine } from 'models/Machine';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const MachineActionType = {
    FETCH_MACHINES: 'FETCH_MACHINES',
    FETCH_MACHINES_SUCCESS: 'FETCH_MACHINES_SUCCESS',
    ADD_MACHINE: 'ADD_MACHINE',
    ADD_MACHINE_SUCCESS: 'ADD_MACHINE_SUCCESS',
    EDIT_MACHINE: 'EDIT_MACHINE',
    EDIT_MACHINE_SUCCESS: 'EDIT_MACHINE_SUCCESS',
    DELETE_MACHINE: 'DELETE_MACHINE',
    DELETE_MACHINE_SUCCESS: 'DELETE_MACHINE_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachinesAction {
    type: typeof MachineActionType.FETCH_MACHINES
    payload: ApiPayload,
    returnPayload: Machine[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachinesAction {
    type: typeof MachineActionType.ADD_MACHINE
    payload: ApiPayload,
    returnPayload: Machine,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachinesAction {
    type: typeof MachineActionType.DELETE_MACHINE
    payload: ApiPayload,
    returnPayload: Machine,
    meta: {
        isApiCall: boolean
    },
}

export type IMachineActions = IFetchMachinesAction | IAddMachinesAction | IDeleteMachinesAction

const baseUrl = 'api/machines';
export class MachineActions {
    public static fetchMachines(token: string): IMachineActions {
        return {
            type: MachineActionType.FETCH_MACHINES,
            payload: Api.fetchApiCall(baseUrl, token, MachineActionType.FETCH_MACHINES_SUCCESS, MachineActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachine(token: string, machinetype: Machine): IMachineActions {
        return {
            type: MachineActionType.ADD_MACHINE,
            payload: Api.postApiCall(baseUrl, token, MachineActionType.ADD_MACHINE_SUCCESS, MachineActionType.API_ERROR, machinetype),
            returnPayload: Machine.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMachine(token: string, machinetype: Machine): IMachineActions {
        return {
            type: MachineActionType.EDIT_MACHINE,
            payload: Api.putApiCall(baseUrl + '/' + machinetype.id, token, MachineActionType.EDIT_MACHINE_SUCCESS, MachineActionType.API_ERROR, machinetype),
            returnPayload: Machine.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachine(token: string, id: number): IMachineActions {
        return {
            type: MachineActionType.DELETE_MACHINE,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachineActionType.DELETE_MACHINE_SUCCESS, MachineActionType.API_ERROR, true),
            returnPayload: Machine.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
